/**
 * Компонент Canvas
 */

import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { getImagesCollection, verticalOffset, horizontalOffset } from '../../helpers/ImageHelper'
import { Promise } from 'q';

export const DOWNLOAD_LINK_CLASS_NAME = 'download-image-for-catalog';

class Canvas extends React.PureComponent {

  static propTypes = {
    className: PropTypes.string,
    updateRender: PropTypes.object,
    width: PropTypes.string,
    height: PropTypes.string,
    size: PropTypes.oneOf(['peview', 'builder', 'xsmall']),
    fabric: PropTypes.string,
    usePlaceholder: PropTypes.bool,
    placeholderSrc: PropTypes.string,
  }

  constructor(props) {
    super(props);
    this.state = {
      isAutoDownloaded: false,
    }
  }

  componentDidMount() {
    this.cache = {}
    this.updateCanvas();
  }

  componentDidUpdate() {
    this.updateCanvas();
  }

  updateCanvas = async () => {
    const { 
      updateRender, 
      type, 
      usePlaceholder,
    } = this.props
    
    const ctx = this.refs.canvas.getContext('2d');

    ctx.fillStyle = "white";

    if (usePlaceholder) this.renderPlaceholder(ctx);

    const promises = [];
    const imagesCollection = getImagesCollection(updateRender, type);
    imagesCollection.forEach(({src}) => {
      promises.push(
        new Promise((resolve) => {
          const image = new Image()
          image.src = src;
          image.onload = function () {
            resolve(image)
          }
          image.onerror = function () {
            console.info(`%cПотерял текстуру: ${src}`, 'color: blue; font-weight: bold;')
            resolve(new Image())
          }
        }).catch(() => {
          resolve(new Image())
        })
      )
    });

    const loadedImages = await this.getImagesAsyncProd(promises, ctx);

    let hOffset;
    let vOffset;

    for (let i = 0; i < loadedImages.length; i++) {
      let img = loadedImages[i];
      const { width, height } = img;
      if (i === 0) {
        if (usePlaceholder && width === 0) break;
        ctx.clearRect(0, 0, width, height)
        ctx.canvas.height = height;
        ctx.canvas.width = width;
        hOffset = horizontalOffset(img, ctx.canvas);
        vOffset = verticalOffset(img, ctx.canvas);
      }
      ctx.drawImage(img, hOffset, vOffset)
    }
  }

  renderPlaceholder = (ctx) => {
    const { placeholderSrc } = this.props

    let img = new Image();
    img.src = placeholderSrc;
    img.height = 545;
    img.width = 400;
    const { width, height } = img;
    img.onload = function () {
      ctx.clearRect(0, 0, width, height)
      ctx.canvas.height = height;
      ctx.canvas.width = width;
      let hOffset = horizontalOffset(img, ctx.canvas);
      let vOffset = verticalOffset(img, ctx.canvas);
      ctx.drawImage(img, hOffset, vOffset)
    }
  }

  getImagesAsyncProd = async (promises) => {
    const start = Date.now();
    const { actions: { imagesLoading } } = this.props;
    imagesLoading(true)
    return Promise.all(promises).then((img) => {
      const end = Date.now();
      setTimeout(() => { imagesLoading(false) }, Math.max(1000 - (end - start), 0));
      return img
    }).catch(err => {
      imagesLoading(false)
    });
  }

  render() {
    const { className } = this.props;
    return (
      <Fragment>
        <canvas ref="canvas" className={className} />
      </Fragment>)
  }
}

Canvas.whyDidYouRender = false;


export default Canvas;